// extracted by mini-css-extract-plugin
export default {"innerAlert":"innerAlert-AJstr","buttons":"buttons-ONhG7"};